import { render, staticRenderFns } from "./ProjectOtherBidders.vue?vue&type=template&id=64d6dc0c&scoped=true&"
import script from "./ProjectOtherBidders.vue?vue&type=script&lang=js&"
export * from "./ProjectOtherBidders.vue?vue&type=script&lang=js&"
import style0 from "./ProjectOtherBidders.vue?vue&type=style&index=0&id=64d6dc0c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d6dc0c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib'
import { VExpandTransition } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSwitch } from 'vuetify/lib'
import { VToolbar } from 'vuetify/lib'
import { VToolbarTitle } from 'vuetify/lib'
installComponents(component, {VAutocomplete,VExpandTransition,VFlex,VIcon,VLayout,VSwitch,VToolbar,VToolbarTitle})
